import { render, staticRenderFns } from "./GobackBar.vue?vue&type=template&id=4642d7a1&scoped=true&"
import script from "./GobackBar.vue?vue&type=script&lang=js&"
export * from "./GobackBar.vue?vue&type=script&lang=js&"
import style0 from "./GobackBar.vue?vue&type=style&index=0&id=4642d7a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4642d7a1",
  null
  
)

export default component.exports